// eslint-disable-next-line import/prefer-default-export
export const FETCH_SALES_OVERVIEW = 'FETCH_SALES_OVERVIEW';
export const SET_SALES_OVERVIEW_TYPE = 'SET_SALES_OVERVIEW_TYPE';
export const REPORT_LOADING_STATE = '';
export const GET_SALES_REPORT = 'GET_SALES_REPORT';
